"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import ChooseEventDatePickerInput from "@/app/(main)/(club)/mes-clubs/[id]/components/choose-event-date-picker-input";
type ParticipationEventDatePickerInputProps = React.ComponentProps<typeof ChooseEventDatePickerInput>;

/**
 * Sélecteur de date d'événement dédié au flux PARTICIPATION.
 *
 * Aujourd'hui il délègue intégralement au `ChooseEventDatePickerInput` partagé :
 * le comportement est identique à celui de l'invitation. Ce composant existe comme
 * POINT D'EXTENSION isolé — toute règle spécifique à la participation (dates
 * sélectionnables, action au clic, source des événements, UX…) se branchera ici,
 * sans impacter les flux d'invitation qui consomment le composant partagé.
 */
export default function ParticipationEventDatePickerInput(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <ChooseEventDatePickerInput {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}